import Image from "next/image";
import React from "react";

interface SectionGridProps {
  bgColor: string;
  title: string | null;
  subtitle: string;
  sections: Array<{
    title: string;
    description: string;
    icon: string;
    serviceItems?: string[];
  }>;
  titleTag: React.ElementType;
  showNumbers?: boolean; // Add this line
}

const SectionGrid: React.FC<SectionGridProps> = ({
  bgColor = "#F9F6ED",
  title,
  subtitle,
  sections,
  titleTag = "p",
  showNumbers = false // Add this line
}) => {
  const TitleTag = titleTag;

  return (
    <section
      id="sectiongrid-36"
      style={{
        backgroundColor: bgColor
      }}
    >
      <div className="tile-container">
        <div className="section-grid">
          <div className="m-auto w-full text-center">
            {title ? (
              <TitleTag className="pb-6 font-heading text-4xlt [text-wrap:balance] @7xl:text-5xlt">{title}</TitleTag>
            ) : null}
            <p className="pb-16 font-matter text-lg [text-wrap:balance] @3xl:text-xl">{subtitle}</p>
          </div>
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 xl:grid-cols-3">
            {sections.map((section, index) => (
              <div key={index} className="rounded-[32px]  p-10">
                <div className="mb-2 flex items-center align-middle">
                  {showNumbers && <span>{index + 1}</span>} {/* Add this line */}
                  {!!section.icon && (
                    <Image src={section.icon} alt={section.title} width={48} height={48} className="mr-4 h-12 w-12" />
                  )}
                  <h3 className="font-heading text-2xl text-primary-700 [text-wrap:balance]">{section.title}</h3>
                </div>
                <p className="text-base text-primary-700 [text-wrap:balance]">{section.description}</p>
                {section.serviceItems && section.serviceItems.length > 0 && (
                  <>
                    <hr className="my-6 border-gray-200" />
                    <h4 className="mb-2 text-base font-semibold">Included Services</h4>
                    <ul className="list-inside list-disc text-sm text-primary-700 [text-wrap:balance]">
                      {section.serviceItems.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionGrid;
